import { CertificateEffect } from './certificate.effect';
import { CpCheckSheetEffect } from './cp-checksheet.effect';
import { CommPkgsEffects } from './cp.effect';
import { DashboardEffect } from './dashboard.effect';
import { DeliveryEffect } from './delivery.effect';
import { DynamicFormEffect } from './dynamic-form.effect';
import { HeatTraceEffect } from './heat-trace.effect';
import { HandoverDocsEffect } from './handover-docs.effect';
import { HandoverDossierEffect } from './handover-dossier.effect';
import { HandoverTemplateEffect } from './handover-template.effect';
import { HandoverEffect } from './handover.effect';
import { McpCheckSheetEffect } from './mcp-checksheet.effect';
import { McpEffect } from './mcp.effect';
import { OfflineDownloadsEffects } from './offline-downloads.effect';
import { OfflineEffects } from './offline.effect';
import { OptionsEffects } from './options.effect';
import { PackageCommonEffects } from './package-common.effect';
import { ProjectAccessEffect } from './project-access.effect';
import { ProjectEffect } from './project.effect';
import { PunchEffect } from './punch.effect';
import { SignatureMatrixEffect } from './signature-matrix.effect';
import { TagEffect } from './tag.effect';
import { TaskEffect } from './task.effect';
import { UserEffects } from './user.effect';
import { ReportEffect } from './report.effect';
import { ResetEffects } from './reset.effect';
import { CheckSheetEffects } from './check-sheet.effect';
import { SupplierEffect } from './supplier.effect';
import { BulkEffect } from './bulk.effect';
import { DocumentEffect } from './document.effect';

import { SystemEffect } from './system.effect';
import { ProjectOverviewEffect } from './project-overview.effect';
import { PunchNotificationEffect } from './punch-notification.effect';
import { UserManualEffects } from './user-manual.effects';
import { RoadmapEffect } from './roadmap.effect';
import { RouterSelectionEffects } from './router-selection.effect';
import { DisciplineEffect } from './discipline.effect';
import { AdminFormEffect } from './admin-form.effect';
import { PunchRoundEffect } from './punch-round.effect';
import { AdminProjectEffect } from './admin-project.effect';
import { GlobalNotificationsEffect } from './global-notifications.effect';
import { PpfpEffects } from './ppfp.effects';

export const effects = [
  CertificateEffect,
  CpCheckSheetEffect,
  CommPkgsEffects,
  DeliveryEffect,
  DynamicFormEffect,
  HeatTraceEffect,
  HandoverDossierEffect,
  HandoverEffect,
  HandoverTemplateEffect,
  HandoverDocsEffect,
  McpEffect,
  McpCheckSheetEffect,
  OptionsEffects,
  OfflineEffects,
  OfflineDownloadsEffects,
  PackageCommonEffects,
  ProjectEffect,
  ProjectAccessEffect,
  PunchEffect,
  SignatureMatrixEffect,
  TagEffect,
  TaskEffect,
  UserEffects,
  DashboardEffect,
  ReportEffect,
  ResetEffects,
  CheckSheetEffects,
  SupplierEffect,
  BulkEffect,
  SystemEffect,
  AdminFormEffect,
  GlobalNotificationsEffect,
  DocumentEffect,
  ProjectOverviewEffect,
  PunchNotificationEffect,
  UserManualEffects,
  RoadmapEffect,
  RouterSelectionEffects,
  DisciplineEffect,
  PunchRoundEffect,
  AdminProjectEffect,
  PpfpEffects,
];

export * from './certificate.effect';
export * from './cp-checksheet.effect';
export * from './mcp-checksheet.effect';
export * from './cp.effect';
export * from './delivery.effect';
export * from './dynamic-form.effect';
export * from './heat-trace.effect';
export * from './handover.effect';
export * from './handover-docs.effect';
export * from './handover-dossier.effect';
export * from './handover-template.effect';
export * from './options.effect';
export * from './package-common.effect';
export * from './project.effect';
export * from './punch.effect';
export * from './signature-matrix.effect';
export * from './tag.effect';
export * from './task.effect';
export * from './user.effect';
export * from './offline.effect';
export * from './offline-downloads.effect';
export * from './project-access.effect';
export * from './dashboard.effect';
export * from './report.effect';
export * from './reset.effect';
export * from './supplier.effect';
export * from './bulk.effect';
export * from './document.effect';
export * from './system.effect';
export * from './check-sheet.effect';
export * from './project-overview.effect';
export * from './punch-notification.effect';
export * from './user-manual.effects';
export * from './roadmap.effect';
export * from './discipline.effect';
export * from './admin-form.effect';
export * from './global-notifications.effect';
export * from './ppfp.effects';
